module.exports = __webpack_public_path__ + "fonts/345f8f50ffba446319c1f5d2ec2e353d.svg";